import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT
  ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
  : "";

/**
 * Fetch the rich snapshot at a specific time.
 * Returns: { snapshot, exitRuleDataGrouped, exitClasses, summary }
 */
export const fetchSnapshotAtTime = async ({ indexName, optionType, onlyDate, onlyTime, isExpiry }) => {
  const params = { indexName, optionType, onlyDate, onlyTime };
  if (isExpiry !== undefined) params.isExpiry = isExpiry;
  const response = await axios.get(`${API_URL}api/exit-snapshot/at-time`, { params });
  return response.data;
};

/**
 * Fetch metadata (available dates and expiries).
 */
export const fetchSnapshotMeta = async ({ indexName, optionType }) => {
  const params = { indexName };
  if (optionType) params.optionType = optionType;
  const response = await axios.get(`${API_URL}api/exit-snapshot/meta`, { params });
  return response.data;
};

/**
 * Fetch all available times for a given date/index/optionType.
 * Returns sorted list of "HH:mm:ss" strings.
 */
export const fetchAvailableTimes = async ({ indexName, optionType, onlyDate, expiry, isExpiry }) => {
  const params = { indexName, optionType, onlyDate };
  if (expiry) params.expiry = expiry;
  if (isExpiry !== undefined) params.isExpiry = isExpiry;
  const response = await axios.get(`${API_URL}api/exit-snapshot/times`, { params });
  return response.data;
};

/**
 * Fetch trade info (entry/exit times, opening type, available times).
 */
export const fetchTradeInfo = async ({ indexName, optionType, onlyDate, isExpiry }) => {
  const params = { indexName, optionType, onlyDate };
  if (isExpiry !== undefined) params.isExpiry = isExpiry;
  const response = await axios.get(`${API_URL}api/exit-snapshot/trade-info`, { params });
  return response.data;
};

/**
 * Fetch exit class detail: all exit conditions evaluated against exitRuleData.
 */
export const fetchB10CEDetail = async ({ indexName, optionType, onlyDate, onlyTime, className, isExpiry }) => {
  const params = { indexName, optionType, onlyDate, onlyTime, className: className || "B10CE" };
  if (isExpiry !== undefined) params.isExpiry = isExpiry;
  const response = await axios.get(`${API_URL}api/exit-snapshot/exit-class-detail`, { params });
  return response.data;
};

/**
 * Generate per-minute exit snapshots for a date.
 */
export const generateSnapshots = async ({ indexName, onlyDate }) => {
  const params = { indexName, onlyDate };
  const response = await axios.get(`${API_URL}api/exit-snapshot/generate`, { params });
  return response.data;
};

/**
 * Fetch exit class trigger counts.
 */
export const fetchB10CETriggerCounts = async ({ indexName, optionType, className, isExpiry }) => {
  const params = { indexName, optionType, className: className || "B10CE" };
  if (isExpiry !== undefined) params.isExpiry = isExpiry;
  const response = await axios.get(`${API_URL}api/exit-snapshot/exit-class-trigger-counts`, { params });
  return response.data;
};

/**
 * Fetch date list from daily_trades collection.
 * Expiry: {index_name, ex_day: 0}
 * Non-expiry: {index_name, ex_day: {$gt:0}, opening_type}
 */
export const fetchDateList = async ({ indexName, isExpiry, openingType }) => {
  const params = { indexName, isExpiry };
  if (openingType) params.openingType = openingType;
  const response = await axios.get(`${API_URL}api/exit-snapshot/date-list`, { params });
  return response.data;
};
